<div class="portfolio">
	@if (checkIsVisible(portfolioBlocksEnum.PORTFOLIO_VALUE)) {
		<div class="block">
			<div
				class="top"
				(click)="toggleExpand(portfolioBlocksEnum.PORTFOLIO_VALUE)"
			>
				<h3 class="title">{{ 'portfolio.portfolioValue' | translate }}</h3>
				<tui-icon
					class="expand-icon"
					[icon]="checkIsExpanded(portfolioBlocksEnum.PORTFOLIO_VALUE) ? '@tui.minus' : '@tui.plus'"
				/>
			</div>

			<tui-expand [expanded]="checkIsExpanded(portfolioBlocksEnum.PORTFOLIO_VALUE)">
				<div class="equity-box">
					<span
						secret
						class="equity"
						[isSecret]="isSecret()"
						secretFontSize="20px"
						[appAnimatedNumber]="alpacaAccount()?.equity | price"
					></span>
					<app-button
						appearance="flat"
						size="xl"
						shape="square"
						[iconStart]="isSecret() ? 'eye-off' : 'eye'"
						(clicked)="toggleSecret()"
					>
					</app-button>
				</div>
			</tui-expand>
		</div>
	}

	@if (checkIsVisible(portfolioBlocksEnum.PROFITABILITY)) {
		<div class="block">
			<div
				class="top"
				(click)="toggleExpand(portfolioBlocksEnum.PROFITABILITY)"
			>
				<h3 class="title">{{ 'portfolio.profitability' | translate }}</h3>
				<tui-icon
					class="expand-icon"
					[icon]="checkIsExpanded(portfolioBlocksEnum.PROFITABILITY) ? '@tui.minus' : '@tui.plus'"
				/>
			</div>

			<tui-expand [expanded]="checkIsExpanded(portfolioBlocksEnum.PROFITABILITY)">
				<div class="box">
					<p class="box-title">{{ 'portfolio.unrealizedPL' | translate }}</p>
					<div class="pl-value-box">
						<span
							class="box-value"
							highlight
							secret
							[tuiSkeleton]="isLoadingPositions()"
							[isSecret]="isSecret()"
							[secretCount]="4"
							[isPositive]="(alpacaAccount()?.unrealizedPLDollar ?? 0) > 0"
							[isNegative]="(alpacaAccount()?.unrealizedPLDollar ?? 0) < 0"
							[isNeutral]="!alpacaAccount()?.unrealizedPLDollar"
							[appAnimatedNumber]="alpacaAccount()?.unrealizedPLDollar | profit: 'dollar'"
						></span>
						<span
							class="box-value"
							highlight
							[tuiSkeleton]="isLoadingPositions()"
							[isPositive]="(alpacaAccount()?.unrealizedPLPercent ?? 0) > 0"
							[isNegative]="(alpacaAccount()?.unrealizedPLPercent ?? 0) < 0"
							[isNeutral]="!alpacaAccount()?.unrealizedPLPercent"
							[appAnimatedNumber]="alpacaAccount()?.unrealizedPLPercent | profit: 'percent'"
						></span>
					</div>
				</div>

				<div class="box">
					<p class="box-title">{{ 'portfolio.perDayPL' | translate }}</p>
					<div class="pl-value-box">
						<span
							class="box-value"
							highlight
							secret
							[tuiSkeleton]="isLoadingPortfolioHistory()"
							[isSecret]="isSecret()"
							[secretCount]="4"
							[isPositive]="(alpacaAccount()?.pLDayDollar ?? 0) > 0"
							[isNegative]="(alpacaAccount()?.pLDayDollar ?? 0) < 0"
							[isNeutral]="!alpacaAccount()?.pLDayDollar"
							[appAnimatedNumber]="alpacaAccount()?.pLDayDollar | profit: 'dollar'"
						></span>
						<span
							class="box-value"
							highlight
							[tuiSkeleton]="isLoadingPortfolioHistory()"
							[isPositive]="(alpacaAccount()?.pLDayPercent ?? 0) > 0"
							[isNegative]="(alpacaAccount()?.pLDayPercent ?? 0) < 0"
							[isNeutral]="!alpacaAccount()?.pLDayPercent"
							[appAnimatedNumber]="alpacaAccount()?.pLDayPercent ?? 0 | profit: 'percent'"
						></span>
					</div>
				</div>
			</tui-expand>
		</div>
	}

	@if (checkIsVisible(portfolioBlocksEnum.PORTFOLIO_VALUATION)) {
		<div class="block">
			<div
				class="top"
				(click)="toggleExpand(portfolioBlocksEnum.PORTFOLIO_VALUATION)"
			>
				<h3 class="title">{{ 'portfolio.portfolioValuation' | translate }}</h3>
				<tui-icon
					class="expand-icon"
					[icon]="checkIsExpanded(portfolioBlocksEnum.PORTFOLIO_VALUATION) ? '@tui.minus' : '@tui.plus'"
				/>
			</div>

			<tui-expand [expanded]="checkIsExpanded(portfolioBlocksEnum.PORTFOLIO_VALUATION)">
				<div class="box">
					<p class="box-title">{{ 'portfolio.marketValue' | translate }}</p>
					<span
						class="box-value portfolio-value"
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						[appAnimatedNumber]="alpacaAccount()?.marketValue | price"
					></span>
				</div>
				<div class="box">
					<p class="box-title">{{ 'portfolio.money' | translate }}</p>
					<span
						class="box-value portfolio-value"
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						[appAnimatedNumber]="alpacaAccount()?.cash | price"
					></span>
				</div>
				<div class="box">
					<p class="box-title">{{ 'portfolio.buyingPowerStocks' | translate }}</p>
					<span
						class="box-value portfolio-value"
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						[appAnimatedNumber]="alpacaAccount()?.buying_power | price"
					></span>
				</div>
				<div class="box">
					<p class="box-title">{{ 'portfolio.buyingPowerOptions' | translate }}</p>
					<span
						class="box-value portfolio-value"
						secret
						[isSecret]="isSecret()"
						[secretCount]="4"
						[appAnimatedNumber]="alpacaAccount()?.options_buying_power | price"
					></span>
				</div>
			</tui-expand>
		</div>
	}

	@if (checkIsVisible(portfolioBlocksEnum.RISK_LEVEL) && +(alpacaAccount()?.equity || 0) > 0) {
		<div class="block">
			<div
				class="top"
				(click)="toggleExpand(portfolioBlocksEnum.RISK_LEVEL)"
			>
				<h3 class="title">{{ 'portfolio.riskLevel' | translate }}</h3>
				<tui-icon
					class="expand-icon"
					[icon]="checkIsExpanded(portfolioBlocksEnum.RISK_LEVEL) ? '@tui.minus' : '@tui.plus'"
				/>
			</div>

			<tui-expand [expanded]="checkIsExpanded(portfolioBlocksEnum.RISK_LEVEL)">
				<div class="risk">
					<tui-badge
						tuiBadge
						[appearance]="badgeAppearance()"
					>
						<p class="risk-value">{{ titleMarginLevelPath() | translate }}</p>
						<p class="risk-value">{{ alpacaAccount()?.multiplier }}X</p>
					</tui-badge>

					<div class="risk-level">
						<p class="risk-level-title">{{ 'portfolio.riskLevel' | translate }}</p>
						<div [class]="['risk-level-items', alpacaAccount()?.riskLevel]">
							@for (isActive of marginLevelStates; let index = $index; track index) {
								<div
									class="risk-level-item"
									[class.filled]="isActive"
								></div>
							}
						</div>
					</div>
				</div>
			</tui-expand>
		</div>
	}
</div>
